<template>
  <div class="property-marks">
    <!-- Cada marca na cor do que quer dizer (ver `propertyFace`); a que vale só às vezes, contornada e
         com "se…", a condição ao passar o mouse -->
    <v-chip v-for="mark of marks" :key="mark.label" size="x-small" label :color="mark.color"
            :variant="mark.condition ? 'outlined' : 'tonal'" :title="mark.condition || undefined">
      <v-icon start size="x-small">{{ mark.icon }}</v-icon>{{ mark.label }}
    </v-chip>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import {PropertyMark} from '@/utils/propertyDefinition'

/**
 * As marcas de sim/não de uma propriedade em selos. Componente porque a linha da propriedade as desenha
 * em um de dois lugares conforme a largura — ao lado dos botões, ou embaixo da frase no telefone
 * (pedido do usuário) —, e a marcação é a mesma nos dois.
 */
@Component({name: 'ontos-property-marks'})
class PropertyMarks extends Vue {
  @Prop({type: Array as () => PropertyMark[], required: true}) readonly marks!: PropertyMark[]
}

export default toNative(PropertyMarks)
</script>

<style scoped>
.property-marks {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
</style>
